<template>
  <div id="buyer">
    <div class="tabbar">
      <div :class="item===selectItem?'isAcitve':''" v-for="(item,index) in tabbarItem" :key="index"
           @click="clickItem(item,index)">
        {{ item }}
      </div>
    </div>
    <div class="filter">
      <div class="select_ground">
        <div class="select_data">
          <el-select v-model="query.time_type" :popper-append-to-body="false" placeholder="选择时间" @change="handleSearch(1)">
            <el-option
              v-for="(item,index) in options"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="select_game">
          <el-select v-model="query.game_id" clearable :popper-append-to-body="false" placeholder="选择游戏"
                     @change="handleSearch(1)">
            <el-option
              v-for="(item,index) in selectGame"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="system_order" @click="handleSystem" v-if="is_show_menu">
          {{ query.list_type == 2 ? '新系统订单' : '原系统订单' }}
          <i class="el-icon-sort"></i>
        </div>
      </div>
      <div class="filter_search">
        <input type="text" class="filter_search_input" v-model="query.keyword" placeholder="请输入账户关键词">
        <span class="filter_search_btn" @click="handleSearch('')">确认</span>
      </div>
    </div>
    <div class="product_list">
      <el-table
        :data="tableData"
        @row-click="tablaRowClick"
        style="width: 100%">
        <!-- 空数据 -->
        <template slot="empty">
          <div class="no_data">
            <empty-state
              title="暂无购买订单"
              description="可以调整筛选条件后再次查看"
              icon="el-icon-shopping-bag-1"
              :icon-size="52">
            </empty-state>
          </div>
        </template>
        <!-- 商品信息 -->
        <el-table-column
          :label="'商品信息（'+totalCount+'条）'"
          width="570">
          <template slot-scope="scope">
            <div class="product">
              <div class="product__img">
                <el-image :src="is_new_list?scope.row.game_image:scope.row.image"></el-image>
              </div>
              <div class="product_info">
                <div class="product_info_top">
                  <img v-if="scope.row.earnest_amount" src="@/assets/image/bargin/bargin-logo.png" alt="">
                  订单号：{{ scope.row.order_no }}
                </div>
                <div class="product_info_mid">
                  <span>{{ scope.row.game_name }}</span>
                  {{ is_new_list ? scope.row.goods_name : scope.row.name }}
                </div>
                <div class="product_info_bot" v-if="is_new_list">
                  下单时间：{{ scope.row.add_time }}
                </div>
                <div class="product_info_bot" v-else>
                  下单时间：{{ scope.row.add_time|moments }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 金额 -->
        <el-table-column
          label="金额">
          <template slot-scope="scope">
            <div class="product_price">¥{{ is_new_list ? scope.row.order_amount : scope.row.price }}</div>
            <div v-if="scope.row.earnest_amount && scope.row.order_status_for_user == '1' && scope.row.pay_type === 2" class="earnest">已付：¥{{scope.row.earnest_amount}}</div>
          </template>
        </el-table-column>
        <!-- 状态 -->
        <el-table-column
          label="状态"
          width="111">
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper" v-if="is_new_list">
              <el-tag v-if="scope.row.order_status_for_user == '1'" type="danger" size="medium">待付款</el-tag>
              <el-tag v-if="scope.row.order_status_for_user == '2'" type="error" size="medium">待发货</el-tag>
              <el-tag v-if="scope.row.order_status_for_user == '3'" type="success" size="medium">已成交</el-tag>
              <el-tag v-if="scope.row.order_status_for_user == '4'" type="info" size="medium">已取消</el-tag>
              <el-tag v-if="scope.row.order_status_for_user == '5'" type="warning" size="medium">退款中</el-tag>
              <el-tag v-if="scope.row.order_status_for_user == '6'" type="warning" size="medium">已退款</el-tag>
            </div>
            <div slot="reference" class="name-wrapper" v-else>
              <el-tag v-if="scope.row.billStatus == '1'" type="danger" size="medium">待付款</el-tag>
              <el-tag v-if="scope.row.billStatus == '2'" type="error" size="medium">待发货</el-tag>
              <el-tag v-if="scope.row.billStatus == '3'" type="success" size="medium">已成交</el-tag>
              <el-tag v-if="scope.row.billStatus == '4'" type="info" size="medium">已取消</el-tag>
            </div>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          label="操作"
          width="100">
          <template slot-scope="scope">
            <div class="btn_ground" v-if="is_new_list">
              <div v-if="scope.row.order_status_for_user === 3 && [1, 2].includes(scope.row.after_sale_status)" class="ask_service" @click.stop="goAfterSales(scope.row)">{{  getAfterSales(scope.row) }}</div>
              <!-- <a v-if="scope.row.sys_service_type == 2&&scope.row.order_status_for_user !='3'" class="ask_service cust_ask" @click.stop="cusSerBtnClicks(scope.row)">咨询客服</a>
              <a
                v-if="scope.row.order_status_for_user !='3'&&scope.row.sys_service_type != 2"
                class="ask_service cust_ask"
                @click.stop @click="$accessLink(scope.row.game_customer)"
                :href="`${scope.row.game_customer}?u_cust_id=${$store.state.userData.user_id}&u_cust_name=${$store.state.userData.nickname}`"
                target="_blank">咨询客服</a> -->
              <div class="pay_count_down" v-if="scope.row.order_status_for_user == '1' && scope.row.pay_type === 2">
                倒计时
                <count-down class="count_down" style="margin: 0 0 0 3px" :key="scope.row.id" :endTime="scope.row.pre_cancel_time"
                            :startTime="scope.row.create_time" format="ms"
                            @countDownChange="countDownChange($event,scope.row)"></count-down>
              </div>
              <div class="confirmReceipt ask_service" v-if="scope.row.order_status_for_user == '1' && scope.row.pay_type === 2"
                   @click.stop="goPayment(scope.row)">
                去支付
              </div>
              <div class="cust_ask" v-if="scope.row.order_status_for_user == '2' && scope.row.pay_type === 2" @click.stop="applyRefund(scope.row)">
                申请退款
              </div>
              <div class="confirmReceipt ask_service"
                   v-if="scope.row.order_status_for_user == '2' && scope.row.receipt_type === 0 && scope.row.auto_receipt_time > 0"
                   @click.stop="confirmReceiptClick(scope.row)">
                确认收货
              </div>
              <!-- <a
                class="ask_service"
                v-if="scope.row.order_status_for_user =='2'||scope.row.order_status_for_user =='3'||scope.row.order_status_for_user =='5'"
                @click.stop="goDetail(scope.row)"
                href="javascript:void();">支付详情</a> -->
            </div>
            <div class="btn_ground" v-else>
              <div v-if="scope.row.order_status_for_user === 3 && [1, 2].includes(scope.row.after_sale_status)" class="cust_ask" @click.stop="goAfterSales(scope.row)">{{  getAfterSales(scope.row) }}</div>
              <a v-if="scope.row.sys_service_type == 2||scope.row.sys_service_type == 3" class="ask_service" @click.stop="cusSerBtnClicks(scope.row)">咨询客服</a>
              <a v-else class="ask_service" @click.stop @click="$accessLink(scope.row.game_customer)"
                 :href="`${scope.row.game_customer}?u_cust_id=${$store.state.userData.user_id}&u_cust_name=${$store.state.userData.nickname}`"
                 target="_blank">咨询客服</a>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pages" v-if="totalCount !== 0">
        <common-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="query.page"
          :page-size="query.pageSize"
          layout="prev, pager, next, jumper"
          :total="totalCount">
        </common-pagination>
      </div>
    </div>
    <wxChatGlobal :visible.sync="merVisible" :describe="customer_describe" :qr_code_url="qr_code_url"></wxChatGlobal>
    <my-dialog :width="'358'" :text="'是否确认已收到货?'" :title="'提示'" btn :show="confirmReceiptShow"
               :close-fun="mydialogClose">
      <div slot="btn" class="confirmReceip-btnGroup">
        <div @click="mydialogClose">取消</div>
        <div @click="manualReceiptClick">确认</div>
      </div>
    </my-dialog>
    <!--  退款申请  -->
    <lendersInfo :visible.sync="lendersInfoShow" :order_id="productInfo.order_id" :game_id="productInfo.game_id"
                 @refresh="handleGetData"></lendersInfo>
    <!-- 申请售后弹窗 -->
    <myDialog
      title="售后原因"
      btn-text="提交"
      btn
      dialog-style="header"
      :show-close="true"
      :close-btn-show="false"
      :show="afterSalesDialog"
      :btn-fuc="afterSalesDialogConfirm"
      :close-fun="() => {
      afterSalesDialog = false
    }">
      <div slot="content" class="after-sales-dialog-cont">
        <span :class="{ 'active-item': afterSalesType === 2 }" @click="afterSalesType = 2">交易纠纷</span>
        <span :class="{ 'active-item': afterSalesType === 1 }" @click="afterSalesType = 1">找回问题</span>
      </div>
    </myDialog>
    <!-- 售后详情弹窗 -->
    <myDialog
      title="售后记录"
      :btn-text="afterSaleDetailBtnText"
      btn
      width="422"
      dialog-style="header"
      :show-close="true"
      :close-btn-show="false"
      box-padding="24px 32px 30px"
      :show="afterSalesDetailDialog"
      :btn-fuc="afterSalesDetailDialogConfirm"
      :close-fun="() => {
      afterSalesDetailDialog = false
    }">
      <div slot="content" class="after-sales-detail-cont custom-scroll-y">
        <PxTimeline :list="timelineList" :step="timelineList.length" />
      </div>
    </myDialog>
  </div>
</template>
<script>
import {
  afterSaleDetailApi,
  afterSaleIntoRoomApi,
  apiGameList,
  apiBuyAccountList,
  apiBuyOrderList,
  apiGetCustomerQrcodeList,
  apiManualReceipt,
  apiOrderRefund,
  apiOrderCancel,
  apiPaydetail,
  apiPaySwitch
} from "@/request/API";
import wxChatGlobal from '../../chat/components/wxChatGlobal.vue';
import myDialog from "@/components/myDialog";
import lendersInfo from "@/views/PersonalCenter/Buyer/components/lendersInfo";
import countDown from "@/components/countDown";
import PxTimeline from "../../../components/PxTimeline.vue";
import CommonPagination from "@/components/commonPagination";
import EmptyState from "@/components/emptyState";

export default {
  name: 'BuyerList',
  props: {},
  components: {
    wxChatGlobal,
    myDialog,
    lendersInfo,
    countDown,
    PxTimeline,
    CommonPagination,
    EmptyState,
  },
  data() {
    return {
      timelineList: [],
      // 售后详情数据
      afterSaleDetail: {},
      afterSalesDetailDialog: false,
      // 2-交易纠纷  1-找回问题
      afterSalesType: 2,
      afterSalesDialog: false,
      afterSalesGameInfo: {},
      query: {
        page: 1,
        pageSize: 10,
        order_status: 0,
        time_type: 0,
        game_id: '',
        keyword: '',
        order_type: 1,
        list_type: 0
      },
      // 默认显示第几页
      // currentPage:1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 0,
      // 默认每页显示的条数（可修改）
      // PageSize:10,
      // tabbar 选中项
      selectItem: '全部订单',
      // tabbar 选中项Index
      selectItemIndex: 0,
      tabbarItem: [
        '全部订单', '待付款', '待发货', '已成交', '已取消'
      ],
      //表格数据
      tableData: [],
      //选择时间下拉框
      options: [
        {value: 0, label: '全部'},
        {value: 1, label: '本周内'},
        {value: 2, label: '当月'},
        {value: 3, label: '三个月内'},
        {value: 4, label: '半年内'},
        {value: 5, label: '半年以上'},
        {value: 6, label: '一年内'},
      ],
      value: '',
      //选择游戏下拉框
      selectGame: [],
      selectGameValue: '',
      //关键词搜索
      // match:'',
      //当前页码
      // page:1
      is_new_list: false,
      is_show_menu: false,
      page: 1,
      merVisible: false,
      customer_describe: '',
      qr_code_url: '',
      //退款信息弹窗
      lendersInfoShow: false,
      //确认收货弹窗
      confirmReceiptShow: false,
      confirmReceiptObj: {},
      productInfo: {},
    }
  },
  methods: {
    // 售后按钮展示
    getAfterSales(orderInfo) {
      const status = orderInfo.after_sale_status
      return status === 1 ? '申请售后' : status === 2 ? '售后详情' : ''
    },
    // 售后弹出
    goAfterSales(orderInfo) {
      this.afterSalesGameInfo = orderInfo
      const status = orderInfo.after_sale_status
      // 申请售后
      if (status === 1) {
        this.afterSalesDialog = true
        return
      }
      // 售后详情
      if (status === 2) {
        afterSaleDetailApi({
          order_id: orderInfo.id
        }).then(res => {
          this.afterSaleDetail = res.data || {}
          this.timelineList = res.data.list
          this.afterSalesDetailDialog = true
        })
      }
    },
    // 售后详情确认
    afterSalesDetailDialogConfirm() {
      const status = this.afterSaleDetail.after_sale_status
      if(status === 2) {
        this.$openIM({
          im_type: 3,
          roomId: this.afterSaleDetail.room_id,
          gameId: this.afterSalesGameInfo.game_id
        })
      }
      if(status === 1) {
        this.afterSalesDetailDialog = false
        this.afterSalesDialog = true
      }
    },
    // 售后确认
    afterSalesDialogConfirm() {
      const {unique_no, order_no, game_id} = this.afterSalesGameInfo.one_order_info
      afterSaleIntoRoomApi({
        order_id: this.afterSalesGameInfo.id,
        type: this.afterSalesType
      }).then(res => {
        if(res.code === 200) {
          this.$openIM({
            afterSalesType: this.afterSalesType,
            gameId: game_id,
            unique_no,
            order_no,
            roomId: res.data.room_id
          })
          // 变更按钮状态
          const selectOrderIdx = this.tableData.findIndex(item => item.one_order_info.unique_no === unique_no)
          this.tableData[selectOrderIdx].after_sale_status = 2
        }
      }).catch(err => this.$message.error(err.msg))
      this.afterSalesDialog = false
    },
    /**
     *
     * @param countDown Boolean 是否超时
     * @param row 行数据
     */
    countDownChange(countDown,row) {
      if (countDown) {
        apiOrderCancel({
          id:row.one_order_info.order_id
        }).then(res=>{
          this.handleSearch(this.query.page)
        }).catch(e=>{
          this.$message({
            type:'error',
            center:true,
            message:e.msg
          })
        })
      }
    },
    /**
     * @description: 申请退款
     * @return {*}
     */
    applyRefund(row) {
/*      if (row.pay_type == 1) {
        this.productInfo.order_id = row.one_order_info.order_id
        this.lendersInfoShow = true
      }else if (row.pay_type == 2){
        apiOrderRefund({
          id:row.one_order_info.order_id
        }).then(res=>{
          this.handleSearch()
        }).catch(e=>{
          this.$message({
            type:'error',
            center:true,
            message:e.msg
          })
        })
      }*/
      this.productInfo.order_id = row.one_order_info.order_id
      this.lendersInfoShow = true
    },
    /**
     * @description: 原系统订单/新系统订单
     * @return {*}
     */
    handleSystem() {
      this.query.list_type = this.query.list_type == 2 ? 1 : 2
      this.handleSearch()
    },
    /**
     * @description: 跳转支付详情
     * @return {*}
     */
    goDetail(row) {
      this.$router.push({
        name: 'BuyerDetail',
        query: {
          id: row.id,
          t: 1
        }
      })
    },
    cusSerBtnClicks(item) {
      apiGetCustomerQrcodeList({
        game_id: item.game_id,
        type: 1
      }).then(res => {
        if (res.data.customer_qr_code_flag == 1) {
          this.customer_describe = res.data.list[0].customer_describe,
            this.qr_code_url = res.data.list[0].qr_code_url
          this.merVisible = true
        } else {
          this.$openIM({
            game_id: item.game_id,
            shopid: item.id,
            product_type: 1,
            gameAlias: item.one_order_info.game_alias
          })
        }
      })
    },
    //table监听事件
    handleEdit(index, row) {
    },
    handleCurrentChange(val) {
      this.query.page = val
      this.handleGetData()
    },
    handleSearch(page) {
      this.query.page = 1
      if (page) {
        this.query.page = page
      }
      this.handleGetData()
    },
    handleGetData() {
      apiBuyOrderList(this.query).then(res => {
        this.tableData = res.data.data
        this.totalCount = res.data.total
        this.is_new_list = res.data.is_new_list
        this.is_show_menu = res.data.is_show_menu
        if (this.is_new_list) {
          this.tabbarItem = ['全部订单', '待付款', '待发货', '已成交', '已取消', '退款']
          this.tableData.forEach(item => {
            item.end_time = Number(new Date(item.add_time).setMinutes(new Date(item.add_time).getMinutes() + 10))
            if (item.one_order_info) {
              item.game_image = item.one_order_info.goods_image || ''
              item.goods_name = item.one_order_info.goods_name || ''
            } else {
              item.game_image = ''
              item.goods_name = ''
            }
          })
        } else {
          this.tableData.forEach(item => {
          })
          this.tabbarItem = ['全部订单', '待付款', '待发货', '已成交', '已取消']
        }
      })
    },
    //表格 row 单击事件
    tablaRowClick(row, column, event) {
      if (this.is_new_list) {
        this.$router.push({
          name: 'BuyerDetail',
          query: {
            id: row.id,
            t: 1
          }
        })
      } else {
        this.$sensorsTrack.AccountClick(
          this.$route.name,
          this.currentPage,
          row.id,
          row.game_name,
          row.game_id,
          row.user_id_sell,
          '',
          '',
          row.id,
          '游戏账号',
          '',
          '',
          '',
          '',
          '',
        )
        this.$router.push({
          name: 'GameDetails',
          query: {
            game_id: row.game_id,
            id: this.is_new_list ? row.one_order_info.goods_id : row.product_id,
            order_id:row.id,
            source_page: this.$route.path.slice(1)
          }
        });
      }
    },
    //tabbar
    clickItem(item, index) {
      this.selectItem = item
      this.query.order_status = index
      this.handleSearch()
    },
    /**
     * 确认收货弹窗关闭
     */
    mydialogClose() {
      this.confirmReceiptShow = false
      this.confirmReceiptObj = {}
    },
    /**
     * 确认收货按钮点击事件
     * @param data 行数据
     */
    confirmReceiptClick(data) {
      this.confirmReceiptShow = true
      this.confirmReceiptObj = data
    },
    /**
     * 确认收货
     */
    manualReceiptClick() {
      apiManualReceipt({
        order_id: this.confirmReceiptObj.id
      }).then(res => {
        this.$message({
          type: "success",
          center: true,
          message: '确认收货成功'
        })
        this.handleSearch()
      }).catch(e => {
        this.$message({
          type: "error",
          center: true,
          message: e.msg
        })
      }).finally(f => {
        this.mydialogClose()
      })

    },
    /**
     * 去支付按钮点击事件
     * @param data
     */
    goPayment(data) {
      this.$router.push({
        name: 'MethodOfPayment',
        query: {
          type: 1,
          orderid: data.id,
          id: data.one_order_info.goods_id,
          gameid: data.game_id,
          amount: this.is_new_list ? data.earnest_amount ? data.balance_amount: data.order_amount : data.price,
          earnest_order_id: data.earnest_order_id
        }
      })
/*      apiPaySwitch({
        game_id: data.game_id,
        type: 1
      }).then(res => {
        if(res.data.is_lianlian_pay == 1){
          this.$router.push({
            name: 'MethodOfPayment',
            query: {
              type: 1,
              orderid: data.id,
              id: data.one_order_info.goods_id,
              gameid: data.game_id,
              amount: this.is_new_list ? data.order_amount : data.price
            }
          })
        } else {
          this.paydetail(data.id)
        }
      })*/
/*      this.$router.push({
        name: 'Payment',
        query: {
          orderid: data.id,
          id: data.one_order_info.goods_id,
          game_id: data.game_id,
        }
      })*/
    },
    /**
     * 生成订单跳转支付宝收银台
     * @param orderid 订单id
     */
    paydetail(orderid){
      apiPaydetail({
        id: orderid,
        return_url:`${process.env.VUE_APP_WEBSITE}/payment?orderid=${orderid}&id=${this.id}&game_id=${this.game_id}`
      }).then(res=>{
        this.alipayFrom = res.data.from_data
        const div = document.createElement("divform");
        div.innerHTML = res.data.from_data
        document.body.appendChild(div);
        document.forms[0].acceptCharset = "GBK"; // 保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
        document.forms[0].submit();
        div.remove();
      })
    },
  },
  created() {
    apiGameList().then(res => {
      res.data.forEach((item, index) => {
        let options = new Object()
        options.value = item.game_id
        options.label = item.game_name
        this.selectGame.push(options)
      })
    })
  },
  mounted() {
    //初始化数据
    if (typeof (this.$route.params.selectItem) !== 'undefined') {
      this.clickItem(this.$route.params.selectItem, this.$route.params.selectItemIndex)
    } else {
      // this.onLoad()
      this.handleGetData()
    }
  },
  watch: {},
  computed: {
    afterSaleDetailBtnText() {
      const status = this.afterSaleDetail.after_sale_status
      return status === 1 ? '重新申请' : status === 2 ? '进入群聊' : ''
    }
  }
}
</script>

<style lang='less'>
.after-sales-dialog-cont {
  display: flex;
  width: 100%;
  gap: 12px;
  margin: 2px 0 24px;

  span {
    display: flex;
    width: 140px;
    height: 44px;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-tag, #F7F5F2);
    color: var(--text-secondary, #5A5F6B);
    font-family: PingFang SC-Regular, PingFang SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    cursor: pointer;
    transition: border-color .2s ease, color .2s ease, background .2s ease, box-shadow .2s ease;
  }

  span:hover {
    border-color: var(--primary, #FF5A1F);
    color: var(--primary, #FF5A1F);
    background: var(--primary-soft, #FCEDE5);
  }

  .active-item {
    border-color: var(--primary, #FF5A1F);
    font-weight: 500;
    color: var(--primary, #FF5A1F);
    background: var(--primary-soft, #FCEDE5);
    box-shadow: none;
  }
}

.change_price_confirm {
  border: none;
  border-radius: 4px !important;
  padding: 0;
  width: 500px !important;
  height: 320px !important;

  background: #fff !important;

  .el-message-box__header > .el-message-box__title {
    display: none;
  }

  .el-message-box__header,
  .el-message-box__content {
    display: flex;

    padding: 0 0 0 70px;

    flex-direction: column;
  }

  .el-message-box__btns {
    display: flex;

    padding: 0;

    align-items: center;
    flex-direction: column;
  }

  .el-message-box__title {
    margin-top: 38px;

    font-family: PingFangSC-Light, PingFang SC;
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;

    color: #5b5b5b;
  }

  .el-message-box__container {
    margin-top: 34px;

    font-family: PingFangSC-Thin, PingFang SC;
    font-size: 16px;
    font-weight: 300;
    line-height: 22px;

    color: #5b5b5b;
  }

  .change_price_confirm_btn {
    margin-top: 20px;
    border: none;
    border-radius: 4px;
    padding: 0;
    width: 200px;
    height: 40px;

    font-family: PingFangSC-Light, PingFang SC;
    font-size: 18px;
    font-weight: 400;
    line-height: 40px;

    color: #fff !important;
    background: var(--primary, #FF5A1F) !important;
  }

  .change_price_confirm_btn:hover {
    background: var(--primary-hover, #E84A12) !important;
  }

  .confirm_content {
    display: flex;

    flex-direction: column;
  }

  .confirm_original_price {
    margin-bottom: 20px;

    font-family: PingFangSC-Light, PingFang SC;
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;

    color: var(--primary, #FF5A1F);
    font-weight: 600;
  }

  .confirm_my_bid {
    margin-bottom: 20px;

    font-family: PingFangSC-Thin, PingFang SC;
    font-size: 20px;
    font-weight: 300;
    line-height: 28px;

    color: #5b5b5b;
  }

  .confirm_modify_bid {
    display: flex;

    align-items: center;
    flex-direction: row;
  }

  .confirm_modify_bid_text {
    font-family: PingFangSC-Thin, PingFang SC;
    font-size: 20px;
    font-weight: 300;
    line-height: 28px;

    color: #5b5b5b;
  }

  .confirm_modify_bid_input {
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    padding: 0 20px;
    width: 210px;
    height: 40px;

    font-family: PingFangSC-Thin, PingFang SC;
    font-size: 16px;
    font-weight: 300;
    line-height: 22px;

    background: #f9f9f9;
  }

  .confirm_modify_bid_tips {
    margin-left: 100px;

    font-family: PingFangSC-Thin, PingFang SC;
    font-size: 16px;
    font-weight: 300;
    line-height: 22px;

    color: #bfbfbf;
  }

  .confirm_modify_bid_input::-webkit-input-placeholder {
    font-family: PingFangSC-Thin, PingFang SC;
    font-size: 16px;
    font-weight: 300;

    color: #d1d1d1;
  }
}


</style>

<style lang='less' scoped>
.after-sales-detail-cont {
  overflow-y: auto;
  width: 100%;
  margin: 0 0 22px;
  max-height: 220px;
  padding: 4px 4px 4px 0;
}

#buyer {
  display: flex;
  flex-direction: column;
  padding: 20px;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  .tabbar {
    display: flex;
    min-height: 40px;
    padding: 4px 0 8px;
    align-items: center;
    gap: 8px;
    overflow: visible;
    border: none;
    border-radius: 0;
    background: transparent;

    div {
      position: relative;
      display: flex;
      min-width: 84px;
      height: 34px;
      padding: 0 16px;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      border-radius: 0;
      color: var(--text-secondary, #5A5F6B);
      font-family: PingFang SC-Regular, PingFang SC;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      cursor: pointer;
      z-index: 0;
      transition: color .2s ease;
    }

    /* 斜切Tab：背景做 skew 平行四边形，文字保持竖直 */
    div::before {
      content: "";
      position: absolute;
      inset: 0;
      background: var(--bg-tag, #F0EDE8);
      transform: skewX(-12deg);
      border-radius: 2px;
      z-index: -1;
      transition: background .2s ease;
    }

    div:hover {
      color: var(--text-main, #1A1D24);
    }

    .isAcitve {
      color: #FFFFFF;
      font-weight: 500;
    }

    .isAcitve::before {
      background: var(--bg-dark, #1A1D24);
    }

    /* 激活态底部 3px 橙色能量条 */
    .isAcitve::after {
      content: "";
      position: absolute;
      inset: 0;
      background: transparent;
      border-bottom: 3px solid var(--primary, #FF5A1F);
      border-radius: 2px;
      transform: skewX(-12deg);
      pointer-events: none;
    }

    .isAcitve:hover {
      color: #FFFFFF;
    }

    div:last-of-type {
      margin: 0;
    }
  }

  .filter {
    display: flex;
    min-height: 40px;
    margin: 18px 0;
    padding: 0;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    gap: 16px;
    border: none;
    border-radius: 0;
    background: transparent;

    .select_ground {
      display: flex;
      align-items: center;
      flex-direction: row;
      gap: 12px;

      /deep/.el-input__inner {
        width: 180px;
        height: 40px;
        padding: 0 34px 0 14px;
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        background: var(--bg-card, #FFFFFF);
        color: var(--text-main, #111827);
        font-size: 14px;
        transition: border-color .2s ease, box-shadow .2s ease;
      }

      /deep/.el-input.is-focus .el-input__inner,
      /deep/.el-input__inner:focus {
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      /deep/.popper__arrow {
        left: 155px !important;
      }

      /deep/.el-select-dropdown {
        border-color: var(--border-soft, #E8E4DE);
        border-radius: 4px;
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      }

      /deep/.el-select-dropdown__item {
        color: var(--text-secondary, #5A5F6B);
      }

      /deep/.el-select-dropdown__item.hover,
      /deep/.el-select-dropdown__item:hover {
        background: var(--bg-tag, #F0EDE8);
      }

      /deep/.el-select-dropdown__item.selected {
        color: var(--primary, #FF5A1F);
        font-weight: 500;
      }

      .select_data {
        margin-right: 0;
      }

      .system_order {
        display: flex;
        height: 34px;
        padding: 0 12px;
        margin-left: 4px;
        align-items: center;
        justify-content: center;
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        background: var(--bg-card, #FFFFFF);
        color: var(--text-secondary, #5A5F6B);
        font-family: PingFang SC-Regular, PingFang SC;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        cursor: pointer;
        transition: border-color .2s ease, color .2s ease, background .2s ease;

        i {
          display: flex;
          margin-left: 5px;
          align-items: center;
          justify-content: center;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background: var(--bg-tag, #F0EDE8);
          color: var(--text-main, #1A1D24);
          font-size: 12px;
          transform: rotate(90deg);
        }
      }

      .system_order:hover {
        border-color: var(--bg-dark, #1A1D24);
        color: var(--text-main, #1A1D24);
        background: var(--bg-tag, #F0EDE8);
      }
    }

    .filter_search {
      display: flex;
      width: 318px;
      height: 40px;
      align-items: center;
      flex-direction: row;
      flex-shrink: 0;
      overflow: hidden;
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      background: var(--bg-card, #FFFFFF);
      transition: border-color .2s ease, box-shadow .2s ease;

      &:focus-within {
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      .filter_search_input {
        width: 100%;
        min-width: 0;
        height: 38px;
        padding: 0 16px;
        border: none;
        outline: none;
        background: transparent;
        color: var(--text-main, #111827);
        font-family: PingFang SC-Regular, PingFang SC;
        font-size: 14px;
        font-weight: 400;
      }

      .filter_search_input::-webkit-input-placeholder {
        color: var(--text-muted, #9AA0AC);
        font-size: 14px;
      }

      .filter_search_btn {
        display: flex;
        width: 92px;
        height: 32px;
        margin-right: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        border-radius: 4px;
        background: var(--primary, #FF5A1F);
        color: #fff;
        font-family: PingFang SC-Regular, PingFang SC;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        cursor: pointer;
        box-shadow: none;
        transition: box-shadow .2s ease, opacity .2s ease, background .2s ease;
      }

      .filter_search_btn:hover {
        opacity: 1;
        background: var(--primary-hover, #E84A12);
      }
    }
  }

  .product_list {
    overflow: hidden;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);

    /deep/.el-table {
      color: var(--text-main, #111827);
    }

    /deep/.el-table:before {
      display: none;
    }

    /deep/.el-table th {
      height: 48px;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
      background: var(--bg-tag, #F7F5F2);
      color: var(--text-secondary, #5A5F6B);
      font-family: PingFang SC-Regular, PingFang SC;
      font-size: 14px;
      font-weight: 500;
    }

    /deep/.el-table th > .cell {
      text-align: center;
    }

    /deep/.el-table .cell {
      padding: 0;
      overflow: visible;
      text-align: center;
    }

    /deep/.el-table td {
      padding: 0;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
    }

    /deep/.el-table__row {
      transition: background .2s ease;
    }

    /deep/.el-table__row:hover {
      cursor: pointer;

      td {
        background: var(--bg-tag, #F7F5F2);
      }
    }

    /deep/.el-tag {
      display: inline-flex;
      height: 28px;
      padding: 0 10px;
      align-items: center;
      border: none;
      border-radius: 4px;
      background: var(--bg-tag, #F0EDE8);
      color: var(--text-main, #1A1D24);
      font-family: PingFang SC-Regular, PingFang SC;
      font-size: 13px;
      font-weight: 500;
    }

    /deep/.el-tag.el-tag--danger {
      background: var(--warning-soft, #F6EEDF);
      color: var(--gold, #C9974D);
    }

    /deep/.el-tag.el-tag--error {
      background: var(--primary-soft, #FCEDE5);
      color: var(--primary, #FF5A1F);
    }

    /deep/.el-tag.el-tag--info {
      background: var(--bg-tag, #F0EDE8);
      color: var(--text-muted, #9AA0AC);
    }

    /deep/.el-tag.el-tag--success {
      background: var(--success-soft, #E4F7EE);
      color: var(--success, #00C16E);
    }

    /deep/.el-tag.el-tag--warning {
      background: var(--danger-soft, #FDE7EC);
      color: var(--danger, #FF2D55);
    }

    .name-wrapper {
      min-height: 28px;
    }

    .product {
      display: flex;
      height: 168px;
      padding: 18px 0 18px 18px;
      align-items: center;
      flex-direction: row;
    }

    .product__img {
      width: 124px;
      height: 124px;
      margin-right: 18px;
      flex: 0 0 124px;
      overflow: hidden;
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      background: var(--bg-tag, #F0EDE8);

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      /deep/.el-image {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .product_info {
      display: flex;
      width: 410px;
      height: 124px;
      min-width: 0;
      flex-direction: column;
      justify-content: space-between;

      .product_info_top {
        display: flex;
        min-height: 24px;
        align-items: center;
        gap: 6px;
        overflow: hidden;
        color: var(--text-secondary, #5A5F6B);
        font-family: PingFang SC-Regular, PingFang SC;
        font-size: 13px;
        font-weight: 400;
        line-height: 22px;
        text-align: left;
        white-space: nowrap;

        img {
          width: 22px;
          height: 22px;
          flex: 0 0 auto;
          object-fit: contain;
        }
      }

      .product_info_mid {
        display: -webkit-box;
        overflow: hidden;
        height: 52px;
        color: var(--text-main, #111827);
        font-family: PingFang SC-Regular, PingFang SC;
        font-size: 15px;
        font-weight: 500;
        line-height: 26px;
        text-align: left;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;

        span {
          display: inline-flex;
          max-width: 120px;
          height: 22px;
          margin: 1px 6px 0 0;
          padding: 2px 8px;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          text-overflow: ellipsis;
          vertical-align: top;
          white-space: nowrap;
          border-radius: 4px;
          background: var(--bg-tag, #F0EDE8);
          color: var(--text-main, #1A1D24);
          font-family: PingFang SC-Regular, PingFang SC;
          font-size: 12px;
          font-weight: 500;
          line-height: 18px;
        }
      }

      .product_info_bot {
        min-height: 22px;
        color: var(--text-muted, #9AA0AC);
        font-family: PingFang SC-Regular, PingFang SC;
        font-size: 12px;
        font-weight: 400;
        line-height: 22px;
        text-align: left;
        white-space: nowrap;
      }
    }

    .product_price {
      color: var(--primary, #FF7A1A);
      font-family: PingFang SC-Regular, PingFang SC;
      font-size: 20px;
      font-weight: 600;
      line-height: 28px;
    }

    .earnest {
      margin-top: 5px;
      color: var(--text-muted, #9AA0AC);
      font-family: PingFang SC-Regular, PingFang SC;
      font-size: 13px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0;
    }

    .btn_ground {
      display: flex;
      min-height: 74px;
      padding: 8px 0;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 8px;

      div,
      a {
        display: flex;
        min-width: 82px;
        height: 30px;
        padding: 0 12px;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        color: var(--text-main, #1A1D24);
        background: var(--bg-tag, #F0EDE8);
        border: 1px solid transparent;
        font-family: PingFang SC-Regular, PingFang SC;
        font-size: 13px;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
        cursor: pointer;
        transition: border-color .2s ease, box-shadow .2s ease, opacity .2s ease, background .2s ease;
      }

      div:hover,
      a:hover {
        opacity: .92;
      }

      .confirmReceipt,
      .ask_service {
        color: #FFFFFF;
        background: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      .confirmReceipt:hover,
      .ask_service:hover {
        background: var(--primary-hover, #E84A12);
        opacity: 1;
      }

      .cust_ask {
        border: 1.5px solid var(--bg-dark, #1A1D24);
        color: var(--text-main, #1A1D24);
        background: var(--bg-card, #FFFFFF);
      }

      .cust_ask:hover {
        border-color: var(--bg-dark, #1A1D24);
        color: var(--text-main, #1A1D24);
        background: var(--bg-tag, #F0EDE8);
      }

      .pay_count_down {
        height: auto;
        min-width: 0;
        padding: 0;
        border: none;
        border-radius: 0;
        background: transparent;
        color: var(--text-main, #1A1D24);
        font-family: PingFang SC-Regular, PingFang SC;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        box-shadow: none;
      }

      .pay_count_down:hover {
        opacity: 1;
      }
    }

    .pages {
      display: flex;
      min-height: 88px;
      align-items: center;
      justify-content: center;
      background: var(--bg-card, #FFFFFF);
    }

    .no_data {
      display: flex;
      min-height: 300px;
      padding: 64px 36px;
      align-items: center;
      justify-content: center;
    }
  }

  .confirmReceip-btnGroup {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;

    div {
      width: 132px;
      height: 38px;
      border: 1.5px solid var(--bg-dark, #1A1D24);
      border-radius: 4px;
      background: var(--bg-card, #FFFFFF);
      color: var(--text-main, #1A1D24);
      font-family: PingFang SC-Regular, PingFang SC;
      font-size: 15px;
      font-weight: 500;
      line-height: 35px;
      text-align: center;
      cursor: pointer;
      user-select: none;
      transition: border-color .2s ease, color .2s ease, background .2s ease, box-shadow .2s ease, opacity .2s ease;
    }

    div:hover {
      border-color: var(--bg-dark, #1A1D24);
      color: var(--text-main, #1A1D24);
      background: var(--bg-tag, #F0EDE8);
    }

    div:last-of-type {
      border: none;
      color: #FFFFFF;
      background: var(--primary, #FF5A1F);
      transition: box-shadow .2s ease, opacity .2s ease, background .2s ease;
    }

    div:last-of-type:hover {
      color: #FFFFFF;
      background: var(--primary-hover, #E84A12);
      box-shadow: 0 10px 22px rgba(255, 90, 31, 0.22);
      opacity: 1;
    }
  }
}


.earnest {
  color: var(--text-muted, #9AA0AC);
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0;
}
</style>
